import { render, staticRenderFns } from "./DangerShipQstPop.vue?vue&type=template&id=59cde72c&scoped=true"
import script from "./DangerShipQstPop.vue?vue&type=script&lang=js"
export * from "./DangerShipQstPop.vue?vue&type=script&lang=js"
import style0 from "./DangerShipQstPop.vue?vue&type=style&index=0&id=59cde72c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cde72c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59cde72c')) {
      api.createRecord('59cde72c', component.options)
    } else {
      api.reload('59cde72c', component.options)
    }
    module.hot.accept("./DangerShipQstPop.vue?vue&type=template&id=59cde72c&scoped=true", function () {
      api.rerender('59cde72c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/DangerShipQstPop.vue"
export default component.exports